import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
	UPLOAD_IMAGE,
	UPLOAD_IMAGE_SUCCESS,
	UPLOAD_IMAGE_FAILED,
	BACK_TO_LOGIN,
	GET_LIST_COUNTRY,
	GET_LIST_COUNTRY_SUCCESS,
	GET_LIST_COUNTRY_FAILED,
	GET_LIST_PROVINCE,
	GET_LIST_PROVINCE_SUCCESS,
	GET_LIST_PROVINCE_FAILED,
	GET_LIST_CITY,
	GET_LIST_CITY_SUCCESS,
	GET_LIST_CITY_FAILED,
	GET_LIST_INDUSTRY,
	GET_LIST_INDUSTRY_FAILED,
	GET_LIST_INDUSTRY_SUCCESS,
} from "constants/ActionTypes";
import {
	uploadImageApi,
	getListCityApi,
	getListProvinceApi,
	getListCountryApi,
	getListIndustryApi,
} from "../../appRedux/api/Common";
import { apiHandler, IDP_INQUIRY_SUCCESS } from "./handler";
import {
    mapLocationCountryRow,
    mapLocationProvinceRow,
    mapLocationCityRow,
    legacyRegistrationOptionsPayload,
} from "../../appRedux/api/idpHelpers";

function* uploadImageProcess({ payload }) {
	try {
		const uploadImage = yield call(uploadImageApi, payload);
		if (uploadImage.data.abstractResponse.responseStatus === "INQ001") {
			yield put({ type: UPLOAD_IMAGE_SUCCESS, payload: uploadImage.data.filePath });
		} else {
			yield put({
				type: UPLOAD_IMAGE_FAILED,
				payload: uploadImage.data.abstractResponse.responseMessage,
			});
		}
	} catch (error) {
		if (error.response && error.response.data.abstractResponse) {
			if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
				yield put({
					type: BACK_TO_LOGIN,
					payload: error.response.data.abstractResponse.responseMessage,
				});
			} else {
				yield put({
					type: UPLOAD_IMAGE_FAILED,
					payload: error.response.data.abstractResponse.responseMessage,
				});
			}
		} else {
			yield put({
				type: UPLOAD_IMAGE_FAILED,
				payload: error.response.data ? error.response.data.responseMessage : "Image upload failed. Something went wrong. Please try again later.",
			});
		}
		// yield put({type: UPLOAD_IMAGE_FAILED, payload: error.data.abstractResponse.responseMessage});
	}
}

function* fetchListCountry() {
	const { ok, data, message } = yield* apiHandler(getListCountryApi, {}, {
		successCodes: IDP_INQUIRY_SUCCESS,
	});

	if (ok) {
		const rows = Array.isArray(data.body) ? data.body.map(mapLocationCountryRow) : [];
		yield put({ type: GET_LIST_COUNTRY_SUCCESS, payload: rows });
	} else {
		yield put({ type: GET_LIST_COUNTRY_FAILED, payload: message });
	}
}

function* fetchListProvince({ payload }) {
	const { ok, data, message } = yield* apiHandler(getListProvinceApi, payload, {
		successCodes: IDP_INQUIRY_SUCCESS,
	});

	if (ok) {
		const rows = Array.isArray(data.body) ? data.body.map(mapLocationProvinceRow) : [];
		yield put({ type: GET_LIST_PROVINCE_SUCCESS, payload: rows });
	} else {
		yield put({ type: GET_LIST_PROVINCE_FAILED, payload: message });
	}
}

function* fetchListCity({ payload }) {
	const { ok, data, message } = yield* apiHandler(getListCityApi, payload, {
		successCodes: IDP_INQUIRY_SUCCESS,
	});

	if (ok) {
		const rows = Array.isArray(data.body) ? data.body.map(mapLocationCityRow) : [];
		yield put({ type: GET_LIST_CITY_SUCCESS, payload: rows });
	} else {
		yield put({ type: GET_LIST_CITY_FAILED, payload: message });
	}
}

function* fetchListIndustry() {
    const { ok, data, message } = yield* apiHandler(getListIndustryApi);

    if (ok) {
        yield put({
            type: GET_LIST_INDUSTRY_SUCCESS,
            payload: legacyRegistrationOptionsPayload(data),
        });
    } else {
        yield put({
            type: GET_LIST_INDUSTRY_FAILED,
            payload: message
        });
    }
}

export function* uploadImage() {
	yield takeEvery(UPLOAD_IMAGE, uploadImageProcess);
}

export function* getListCountry() {
	yield takeEvery(GET_LIST_COUNTRY, fetchListCountry);
}

export function* getListProvince() {
	yield takeEvery(GET_LIST_PROVINCE, fetchListProvince);
}

export function* getListCity() {
	yield takeEvery(GET_LIST_CITY, fetchListCity);
}

export function* getListIndustry() {
	yield takeEvery(GET_LIST_INDUSTRY, fetchListIndustry);
}

export default function* rootSaga() {
	yield all([
		fork(uploadImage),
		fork(getListCountry),
		fork(getListProvince),
		fork(getListCity),
		fork(getListIndustry),
	]);
}
